import classNames from 'classnames';
import _ from 'lodash';
import type { ToggleButtonProps } from './types';
import { useToggleButton } from './useToggleButton';
import './toggleButton.scss';

/**
 * Placeholder callback standing in for the toggle button's key handler. Takes no arguments and performs no work.
 *
 * @returns Nothing.
 */
const NOOP = () => {};

/**
 * Button representing one option of a toggle group, optionally showing a count badge. Applies the active class when isActive, renders the option label with its sub-label and a count span whenever count is not nil, and delegates activation to onClick from useToggleButton.
 *
 * @param props - Option data and id, active and disabled state, sub-label and count, class name and the key handler.
 * @returns The rendered toggle button element.
 */
const ToggleButton = (props: ToggleButtonProps) => {
  const {
    id = undefined,
    className = undefined,
    subLabel = '',
    disabled = false,
    onKeyDown = NOOP,
    count = undefined,
  } = props;
  const { onClick } = useToggleButton(props);

  return (
    <button
      id={id}
      disabled={disabled}
      onKeyDown={onKeyDown}
      onClick={onClick}
      className={classNames('toggle-button', props.isActive ? '--active' : '', className)}
    >
      <span
        className={classNames('content', {
          'pr-2': !_.isNil(count),
        })}
      >
        {props.data.label}
        {subLabel}
      </span>
      {!_.isNil(count) && <span className="count">{count}</span>}
    </button>
  );
};

export default ToggleButton;
